<po-widget class="po-lg-12 po-mb-1 clickable-card" *ngFor="let item of orders; let i = index"
    (click)="onClickOrder(item)">
    <div class="po-row po-pb-1" style="border-bottom: 1px solid #d3d3d3;">
        <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12 po-row justify-center po-mb-1">
            <po-tag [p-value]="getStatusLabel(item.allocationStatus)"
                [p-type]="getStatusColor(item.allocationStatus)"></po-tag>
        </div>
        <div class="po-xl-6 po-lg-6 po-md-12 po-sm-12">
            <span class="po-text-color-01 po-font-text-bold">Pedido:</span>
            <span class="po-ml-1">{{ item.orderCode }}</span>
        </div>
    </div>
    <div class="po-row po-pt-1">
        <div class="po-xl-6 po-lg-6 po-md-12 po-sm-12">
            <span class="po-text-color-01 po-font-text-bold">Empresa:</span>
            <span class="po-ml-1">{{ item.orderBranchCode }}</span>
        </div>
        <div class="po-xl-6 po-lg-6 po-md-12 po-sm-12">
            <span class="po-text-color-01 po-font-text-bold">Cliente:</span>
            <span class="po-ml-1">{{ item.customerCode}}</span>
        </div>
    </div>
    <div class="po-row po-pt-1">
        <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
            <span class="po-text-color-01 po-font-text-bold">Descrição:</span>
            <span class="po-ml-1">{{item.customerName}}</span>
        </div>
        <div class="po-xl-6 po-lg-6 po-md-12 po-sm-12">
            <span class="po-text-color-01 po-font-text-bold">Data do Pedido:</span>
            <span class="po-ml-1">{{item.orderDate | date:'dd/MM/yyyy'}}</span>
        </div>
    </div>
</po-widget>